import { ProjectStateAsString } from 'controllers/Project/ProjectStateMachine'
import { RootAppState } from 'store/configureStore'

export const projectStatusSelector = (state: RootAppState) => {
  return state.project.activeProject?.status as ProjectStateAsString
}
